export default function nodeToEntry (node){
	const key = node.key;
	const value = node.val();
	return {key, value};
}
